module.exports = __webpack_public_path__ + "img/ertiga-xl7-naranja-sideral.7edcc248.png";